var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.605,
    height: 23.478,
    viewBox: "0 0 17.605 23.478",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-excel",
    d: "M16.958,4.393,13.112.546A2.2,2.2,0,0,0,11.558-.1H2.2A2.208,2.208,0,0,0,0,2.105V21.177a2.2,2.2,0,0,0,2.2,2.2H15.4a2.2,2.2,0,0,0,2.2-2.2V5.952a2.211,2.211,0,0,0-.646-1.559Zm-1.733,1.38H11.736V2.284ZM2.2,21.177V2.105H9.536V6.873a1.1,1.1,0,0,0,1.1,1.1H15.4v13.2Zm9.719-11H10.6a.545.545,0,0,0-.481.289,23.957,23.957,0,0,0-1.311,2.645c-.637-1.334-.316-.793-1.311-2.645a.552.552,0,0,0-.486-.289H5.685A.55.55,0,0,0,5.208,11l2.123,3.576L5.208,18.151a.548.548,0,0,0,.477.825H7.01a.545.545,0,0,0,.481-.289A23.836,23.836,0,0,0,8.8,16.042c.683,1.385.27.729,1.311,2.645a.552.552,0,0,0,.486.289h1.32a.55.55,0,0,0,.477-.825l-2.127-3.576c.032-.05,1.389-2.315,2.123-3.576A.548.548,0,0,0,11.92,10.174Z",
    transform: "translate(0 0.1)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileExcel);
export default __webpack_public_path__ + "static/media/file-excel.ec9f3df3cec238a12d686e79db9bee38.svg";
export { ForwardRef as ReactComponent };